/**
 * Hotspot Banner - Interactive product dots with category filters
 * Replaces React HotspotBanner.tsx
 */
(function () {
  'use strict';

  document.querySelectorAll('[data-hotspot-banner]').forEach(function (section) {
    var pins = section.querySelectorAll('[data-hotspot-pin]');
    var cards = section.querySelectorAll('[data-hotspot-card]');
    var filterBtns = section.querySelectorAll('[data-hotspot-filter]');
    var overlay = section.querySelector('[data-hotspot-overlay]');
    var activeIndex = null;

    /* ── Close all cards ── */
    function closeAll() {
      cards.forEach(function (card) {
        card.classList.remove('is-visible');
        card.setAttribute('aria-hidden', 'true');
      });
      pins.forEach(function (pin) {
        pin.classList.remove('is-active');
      });
      if (overlay) overlay.classList.remove('is-active');
      activeIndex = null;
    }

    /* ── Position card near its pin (desktop only) ── */
    function positionCard(card, pin) {
      // On mobile, card is fixed full-width at bottom — skip positioning
      if (window.innerWidth < 750) return;

      var media = pin.closest('.hotspot-banner__media');
      if (!media) return;

      var mRect = media.getBoundingClientRect();
      var pRect = pin.getBoundingClientRect();

      // Reset inline positioning
      card.style.position = 'absolute';
      card.style.bottom = '';
      card.style.left = '';
      card.style.right = '';
      card.style.top = '';

      var pinCX = pRect.left - mRect.left + pRect.width / 2;
      var pinCY = pRect.top - mRect.top + pRect.height / 2;
      var cardW = 260;
      var cardH = card.offsetHeight || 340;

      // Horizontal: prefer right of pin, flip if overflow
      var x = pinCX + 24;
      if (x + cardW > mRect.width) {
        x = pinCX - cardW - 24;
      }
      if (x < 0) x = 8;

      // Vertical: center on pin, shift if overflow
      var y = pinCY - cardH / 2;
      if (y < 0) y = 8;
      if (y + cardH > mRect.height) y = mRect.height - cardH - 8;

      card.style.left = x + 'px';
      card.style.top = y + 'px';
    }

    /* ── Toggle a hotspot ── */
    function toggleHotspot(index) {
      if (activeIndex === index) {
        closeAll();
        return;
      }

      closeAll();

      var pin = section.querySelector('[data-hotspot-pin="' + index + '"]');
      var card = section.querySelector('[data-hotspot-card="' + index + '"]');

      if (pin && card) {
        pin.classList.add('is-active');
        positionCard(card, pin);
        card.classList.add('is-visible');
        card.setAttribute('aria-hidden', 'false');
        if (overlay && window.innerWidth < 750) {
          overlay.classList.add('is-active');
        }
        activeIndex = index;
      }
    }

    /* ── Pin click handlers ── */
    pins.forEach(function (pin) {
      pin.addEventListener('click', function (e) {
        e.stopPropagation();
        toggleHotspot(this.getAttribute('data-hotspot-pin'));
      });
    });

    /* ── Close button handlers ── */
    section.querySelectorAll('[data-hotspot-close]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        closeAll();
      });
    });

    /* ── Overlay click closes ── */
    if (overlay) {
      overlay.addEventListener('click', closeAll);
    }

    /* ── Click outside closes ── */
    document.addEventListener('click', function (e) {
      if (activeIndex !== null &&
          !e.target.closest('[data-hotspot-card]') &&
          !e.target.closest('[data-hotspot-pin]') &&
          !e.target.closest('[data-hotspot-overlay]')) {
        closeAll();
      }
    });

    /* ── Category filter logic ── */
    filterBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var category = this.getAttribute('data-hotspot-filter');

        // Update active state
        filterBtns.forEach(function (b) { b.classList.remove('is-active'); });
        this.classList.add('is-active');

        // Close any open card
        closeAll();

        // Show/hide hotspots by category
        pins.forEach(function (pin) {
          var pinCat = pin.getAttribute('data-hotspot-category');
          var hidden = category !== 'all' && pinCat !== category;
          pin.setAttribute('data-hotspot-hidden', hidden ? 'true' : 'false');
        });

        cards.forEach(function (card) {
          var cardCat = card.getAttribute('data-hotspot-category');
          var hidden = category !== 'all' && cardCat !== category;
          card.setAttribute('data-hotspot-hidden', hidden ? 'true' : 'false');
        });
      });
    });

    /* ── Recalculate on resize ── */
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        if (activeIndex !== null) {
          var pin = section.querySelector('[data-hotspot-pin="' + activeIndex + '"]');
          var card = section.querySelector('[data-hotspot-card="' + activeIndex + '"]');
          if (pin && card && card.classList.contains('is-visible')) {
            positionCard(card, pin);
          }
        }
      }, 100);
    });

    /* ── Shopify theme editor support ── */
    if (Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:select', function () { closeAll(); });
      document.addEventListener('shopify:block:select', function (e) {
        var block = e.target;
        var pin = block.querySelector('[data-hotspot-pin]');
        if (pin) {
          toggleHotspot(pin.getAttribute('data-hotspot-pin'));
        }
      });
      document.addEventListener('shopify:block:deselect', function () { closeAll(); });
    }
  });
})();
